const announcementBar = document.querySelector(".announcement-bar");
const headerCustom = document.querySelector(".header--custom");
const headerPosition = document.querySelector(".header-position");
// Options for the intersection observer
const optionsHeader = {
  root: null,
  rootMargin: "0px",
  threshold: 0.5, // Change this value based on your requirement
};

// Callback function to handle intersection changes
const callbackHeader = (entries, observer) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      // Announcement bar is not visible
      // headerCustom.style.backgroundColor = "rgba(var(--color-background))"; // Change the background color as needed
      headerCustom.setAttribute("data-intersecting", "true");
    } else {
      // Announcement bar is visible
      // headerCustom.style.backgroundColor = "transparent"; // Reset background color
      headerCustom.setAttribute("data-intersecting", "false");
    }
  });
};

// Create an intersection observer
const observerHeader = new IntersectionObserver(callbackHeader, optionsHeader);

// Start observing the announcement bar
if (announcementBar) {
  observerHeader.observe(announcementBar);
} else {
  observerHeader.observe(headerPosition);
}
